<template>
  <div class="home-box">
    <div class="home-pannel">
      <div class="home-pannel-placeholder"></div>
      <div class="home-pannel-list">
        <div class="list-item-wrap" v-for="(item, index) in menuList" :key="index">
          <div class="list-item" @click="handleListItemClick(index)">
            <div class="list-item-icon">
              <img :src="item.imgUrl" />
            </div>
            <div class="list-item-name">{{ item.name }}</div>
          </div>
        </div>
      </div>
      <div class="home-pannel-url">
        <div class="tips">大屏体验地址 :</div>
        <div class="text">
          <a :href="screenUrl" target="_blank">{{ screenUrl }}</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      screenUrl:
        'http://111.30.93.214:9100/project/703a68dc693c8b26be1d4bf0c9/573a68c1662399/?page=jn'
    }
  },
  beforeCreate() {
    this.menuList = [
      {
        name: '管片年度生产',
        imgUrl: require('../../assets/opration/home_list_icon1.png'),
        menuId: '',
        path: 'PieceProduct'
      },
      {
        name: '静养监控',
        imgUrl: require('../../assets/opration/home_list_icon2.png'),
        menuId: '',
        path: 'RestMonitor'
      },
      {
        name: '水养监控',
        imgUrl: require('../../assets/opration/home_list_icon3.png'),
        menuId: '',
        path: 'WatertMonitor'
      },
      {
        name: '堆场监控',
        imgUrl: require('../../assets/opration/home_list_icon4.png'),
        menuId: '',
        path: 'YardMonitor'
      },
      {
        name: '管片发运',
        imgUrl: require('../../assets/opration/home_list_icon5.png'),
        menuId: '',
        path: 'DuctDespatch'
      }
    ]
  },
  created() {
    this.setMenuId()
  },
  methods: {
    // 填充menuList的menuId,同时跳转时传递此字段
    setMenuId() {
      let screenCmsLists = sessionStorage.getItem('screenCmsLists')
      screenCmsLists = screenCmsLists ? JSON.parse(screenCmsLists) : []
      screenCmsLists.forEach(item => {
        let findMenu = this.menuList.find(ele => ele.name === item.menuName)
        if (findMenu) {
          findMenu.menuId = item.menuId
        }
      })
    },
    // 列表跳转
    handleListItemClick(index) {
      let { path, menuId } = this.menuList[index]
      this.$router.push({ path, query: { menuId } })
    }
  }
}
</script>
<style scoped lang="scss">
/* 滚动条统一样式修改 */
/deep/ {
  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  &::-webkit-scrollbar-corner {
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    box-shadow: inset 0 0 5px transparent;
    background: #39b5fe;
  }

  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px transparent;
    border-radius: 10px;
    background: rgba(76, 188, 254, 0.3);
  }
}
.home-box {
  position: absolute;
  width: 100%;
  height: 100%;
  font-size: 18px;
  background-color: #f6f8fe;
  background-image: url('../../assets/opration/rest_bgh.png');
  background-repeat: no-repeat;
  background-size: 100% auto;

  &::after {
    content: '首页';
    position: absolute;
    width: 100%;
    left: 0;
    top: 3%;
    font-size: 20px;
    text-align: center;
    color: #fff;
  }
}

.home-pannel {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  margin: auto;

  .home-pannel-placeholder {
    height: 80px;
  }

  .home-pannel-list {
    overflow: auto;
    flex: 1;

    .list-item-wrap {
      float: left;
      width: 50%;
      .list-item {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        width: 160px;
        max-width: 100%;
        height: 140px;
        margin: 0 auto 40px auto;
        text-indent: 20px;
        background: url(../../assets/opration/home_list_bg.png) no-repeat;
        background-size: 100% 100%;
      }

      .list-item-icon img {
        width: 60px;
      }
    }
  }

  .home-pannel-url {
    width: 94%;
    margin: 0 auto 20px auto;
    padding: 10px;
    text-align: left;
    color: #666666;
    background: #ffffff;
    box-shadow: 0px 0px 16px 0px rgba(35, 126, 255, 0.2);
    border-radius: 4px;

    .text {
      padding: 4px;
      margin-top: 10px;
      font-size: 14px;
      word-break: break-all;
      color: #237eff;
      background: #e2eeff;
    }
  }
}

@media only screen and (min-width: 600px) {
  .home-box {
    position: absolute;
    width: 600px;
    left: 50%;
    transform: translateX(-50%);
  }
  .home-pannel {
    .home-pannel-list {
      .list-item-wrap {
        .list-item {
          justify-content: space-evenly;
          width: 235px;
          height: 200px;
          font-size: 24px;
          font-weight: bold;
          text-indent: 32px;
          cursor: pointer;
        }
        .list-item-icon img {
          width: 90px;
        }
        &:nth-child(2n) {
          .list-item {
            margin-left: 20px;
            margin-bottom: 30px;
          }
        }
        &:nth-child(2n + 1) {
          .list-item {
            margin-left: 40px;
            margin-bottom: 30px;
          }
        }
      }
    }
  }
}
</style>
